<script setup lang="ts">
// import img1 from '@/assets/loginPost/1.webp'
// import img2 from '@/assets/loginPost/2.webp'
import img3 from '@/assets/loginPost/3.webp'
import img4 from '@/assets/loginPost/4.webp'
import img5 from '@/assets/loginPost/5.webp'
import img6 from '@/assets/loginPost/6.webp'
import img7 from '@/assets/loginPost/7.webp'
import img8 from '@/assets/loginPost/8.webp'
import logo from '/logo-new.png'

const { t } = useI18n()
const dataList = computed(() => {
  return [
    {
      title: t('login.postTitle8'),
      desc: t('login.postDesc8'),
      image: img8,
      pic: logo,
      name: 'dfans',
    },
    // {
    //   title: t('login.postTitle1'),
    //   desc: t('login.postDesc1'),
    //   image: img1,
    //   pic: logo,
    //   name: 'dfans',
    //   url: 'https://blog.dfans.xyz/decentralized-latform.html',
    // },
    {
      title: t('login.postTitle7'),
      desc: t('login.postDesc7'),
      image: img7,
      pic: logo,
      name: 'dfans',
    },
    // {
    //   title: t('login.postTitle2'),
    //   desc: t('login.postDesc2'),
    //   image: img2,
    //   pic: logo,
    //   name: 'dfans',
    //   url: 'https://blog.dfans.xyz/USDT-Payout.html',
    // },
    {
      type: 'text',
    },
    {
      title: t('login.postTitle3'),
      desc: t('login.postDesc3'),
      image: img3,
      pic: logo,
      name: 'dfans',
      url: 'https://blog.dfans.xyz/Subscription-Upgrade.html',
    },
    {
      title: t('login.postTitle4'),
      desc: t('login.postDesc4'),
      image: img4,
      pic: logo,
      name: 'dfans',
      url: 'https://blog.dfans.xyz/Introducing-dfans-Collection.html',
    },
    {
      title: t('login.postTitle5'),
      desc: t('login.postDesc5'),
      image: img5,
      pic: logo,
      name: 'dfans',
      url: 'https://blog.dfans.xyz/message.html',
    },
    {
      title: t('login.postTitle6'),
      desc: t('login.postDesc6'),
      image: img6,
      pic: logo,
      name: 'dfans',
      url: 'https://blog.dfans.xyz/Introduces-Geo-Blocking.html',
    },
  ]
})

const jumpBlog = (item: any) => {
  window.open(item.url, '_blank')
}
</script>

<template>
  <div class="sm:py-9 py-8 sm:w-175 w-full mx-auto dark:bg-brandD">
    <div class="text-7 leading-9 sm:text-8 sm:leading-10 sm:px-0 sm:mb-9 px-4 mb-8">
      {{ t('Global.DifferencesFromOtherPlatforms') }}
    </div>
    <div v-for="(item, index) in dataList" :key="index" class="sm:px-0 px-4">
      <div
        v-if="item?.type === 'text'"
        class="text-7 leading-9 sm:text-8 sm:leading-10 sm:my-9 sm:px-0 px-2 my-8"
      >
        {{ t('Global.LatestFeaturedPosts') }}
      </div>
      <div
        v-else
        class="w-full overflow-hidden bg-white dark:bg-op-40 dark:bg-black rounded-md mb-5 pt-3.5 shadow"
      >
        <main class="w-full flex flex-col">
          <div class="px-4 sm:mt-1">
            <div
              class="typeface-robotoMedium text-lg sm:text-7 sm:leading-10.5 ellipsis-2 dark:text-brandC text-brandD"
            >
              {{ item.title }}
            </div>
            <div class="text-base mt-1 text-op-80 ellipsis-3 dark:text-brandC text-brandD">
              {{ item.desc }}
            </div>
            <!-- <div
              class="h-5 text-sm font-bg cursor-pointer mt-2 w-max lineBox font-hover text-gradient-hover"
              @click="jumpBlog(item)"
            >
              {{ t('Btn.ReadMoreEtc') }}
            </div> -->
          </div>
          <img class="w-full mt-3" :src="item.image" :alt="item.desc" title="dfans" />
        </main>
      </div>
    </div>
    <div class="sm:px-0 px-4">
      <JoinAPlatformThatCares />
      <div class="rounded-3 px-4 py-10 mt-8 sm:mt-9 dark:bg-brand bg-brandB bg-op-10">
        <div
          class="flex items-center justify-center flex-col sm:flex-row typeface-robotoMedium text-2xl"
        >
          <span>{{ t('Global.SignUpThisMonth') }}</span>
          <span class="font-bg ml-1">{{ t('Global.earnShares') }}</span>
        </div>
        <div class="text-center sm:mt-4 mt-5 text-base text-brandB">
          {{ t('Global.earnSharesDesc') }}
        </div>
        <BecomeCreatorBtn class="mt-7.5" type="default" />
      </div>
    </div>
  </div>
</template>
